"use client";

import Slider, { SliderProps } from "rc-slider";
import "rc-slider/assets/index.css";
import { useCallback, useState } from "react";
import { useClickAway } from "src/lib/hooks/useClickAway";

type PNumSlider = {
  num: number;
  min?: number;
  max?: number;
  step?: number;
  percent?: number;
  onChange: SliderProps["onChange"];
};
export const NumSlider = ({
  min = 1,
  max = 10,
  step = 1,
  percent,
  num,
  onChange,
}: PNumSlider) => {
  const [showSlider, setShowSlider] = useState(false);
  const toggleSlider = useCallback(() => {
    setShowSlider(!showSlider);
  }, [showSlider]);
  const ref = useClickAway(() => setShowSlider(false));

  return (
    <span
      className="sc-code-bg-color inline-block border border-nord-3-5 px-1 mx-1 rounded-sm shadow whitespace-nowrap bg-nord-4"
      style={{ cursor: "pointer" }}
    >
      <span
        ref={ref}
        className="z-50"
        style={{
          width: 100,
          display: showSlider ? "inline-block" : "none",
          position: "absolute",
          marginLeft: -30,
          marginTop: -15,
        }}
      >
        <Slider
          min={min}
          max={max}
          step={step}
          value={num}
          onChange={onChange}
          draggableTrack
        />
      </span>
      <button
        className="focus:outline-hidden font-mono text-sm"
        onClick={toggleSlider}
      >
        {num}
        {percent ? "%" : ""}
      </button>
    </span>
  );
};
